import { Toaster } from 'sonner'
import { createPortal } from 'react-dom'
import { useEffect, useState } from 'react'

const TOAST_ROOT_ID = 'toast-root'

const SystemToastContainer = () => {
  const [toastRoot, setToastRoot] = useState(
    document.getElementById(TOAST_ROOT_ID),
  )

  useEffect(() => {
    let root = document.getElementById(TOAST_ROOT_ID)
    if (!root) {
      root = document.createElement('div')
      root.id = TOAST_ROOT_ID
      document.body.appendChild(root)
    }
    setToastRoot(root)
  }, [])

  if (!toastRoot) return null

  return createPortal(
    <Toaster
      gap={8}
      theme="dark"
      visibleToasts={3}
      id="system-bottom-toaster"
      position="bottom-center"
    />,
    toastRoot,
  )
}

export { SystemToastContainer, TOAST_ROOT_ID }
